// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === MAIN PAGE LAYOUT === */
.products-page .page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.products-page .page-header h3 {
  font-size: 28px;
  font-weight: 600;
  color: #111827;
}

/* Reusing your page controls and search bar styles */
.page-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
}
.filter-btn img {
  height: 20px;
}
.page-search-bar {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0 12px;
  width: 300px;
}
.page-search-bar img {
  height: 16px;
  opacity: 0.5;
}
.page-search-bar input {
  border: none;
  outline: none;
  padding: 10px 8px;
  font-size: 14px;
  flex-grow: 1;
  background: transparent;
}

/* === MAIN CONTENT WRAPPER & TABS === */
.page-content-wrapper {
  background: #ffffff;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  padding: 24px;
}
.product-tabs {
  border-bottom: 2px solid #f3f4f6;
}
.product-tabs button {
  background: none;
  border: none;
  padding: 0 5px 15px 5px;
  margin-right: 30px;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  position: relative;
  font-weight: 500;
}
.product-tabs button.active {
  color: #f97316;
  font-weight: 600;
}
.product-tabs button.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #f97316;
}
.product-content {
  padding-top: 24px;
}

@media (max-width: 900px) {
  .page-content-wrapper {
    padding: 12px;
  }
  .product-tabs button {
    margin-right: 12px;
    font-size: 14px;
  }
}
@media (max-width: 600px) {
  .page-content-wrapper {
    padding: 8px;
  }
  .product-tabs {
    flex-wrap: wrap;
  }
}

/* === TABLE & PAGINATION STYLES (REUSED FROM YOUR REFERENCE) === */
.table-container {
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th,
.data-table td {
  padding: 16px 24px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
  white-space: nowrap;
  vertical-align: middle; /* Ensures content aligns nicely */
}
.data-table th {
  background-color: #f2f7ff;
  color: #1e3a8a;
  font-weight: 600;
  text-transform: none;
}
.data-table td {
  color: #374151;
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}
.action-icon {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
  height: 18px;
}
.action-icon:hover {
  opacity: 1;
}

/* Specific style for the product image in the table */
.product-image {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  object-fit: cover;
}

/* Reusing your status badge styles */
.status-badge {
  padding: 5px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}
.status-active {
  background-color: #def7ec;
  color: #046c4e;
}
.status-inactive {
  background-color: #fef3c7;
  color: #92400e;
}
/* You can add more status colors here as needed */

/* Reusing your page footer and pagination styles */

/* Placeholder and loading styles */
.page-loading,
.page-error {
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: #6b7280;
}

.status-dropdown-container {
  position: relative;
  display: inline-block;
}

.status-badge-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background: white;
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 200px;
  max-height: 300px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.chevron-icon {
  width: 12px;
  height: 12px;
  transition: transform 0.2s;
}

.chevron-icon.open {
  transform: rotate(180deg);
}

.status-badge {
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.status-badge-wrapper.updating {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Status Colors */
.bg-blue-100 {
  background-color: #dbeafe;
}
.text-blue-800 {
  color: #1e40af;
}

.bg-green-100 {
  background-color: #dcfce7;
}
.text-green-800 {
  color: #166534;
}

.bg-red-100 {
  background-color: #fee2e2;
}
.text-red-800 {
  color: #991b1b;
}

.bg-yellow-100 {
  background-color: #fef9c3;
}
.text-yellow-800 {
  color: #854d0e;
}

.bg-purple-100 {
  background-color: #f3e8ff;
}
.text-purple-800 {
  color: #6b21a8;
}

.bg-indigo-100 {
  background-color: #e0e7ff;
}
.text-indigo-800 {
  color: #3730a3;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}
.text-gray-800 {
  color: #1f2937;
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 4px;
  margin: 4px;
}

.dropdown-item:hover {
  opacity: 0.8;
}

.action-cell {
  white-space: nowrap;
  /* background-color: #6b21a8; */
  display: flex;
  justify-content: start;
}

.center-text {
  text-align: center;
}

.action-icon {
  width: 20px;
  height: 20px;
  margin: 0 5px;
  cursor: pointer;
}
.products-page .all-products-tab > .list-header {
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProductsPage/ProductsPage.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,sBAAsB,EAAE,kCAAkC;AAC5D;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA,kDAAkD;;AAElD,mDAAmD;;AAEnD,mCAAmC;AACnC;;EAEE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["/* === MAIN PAGE LAYOUT === */\n.products-page .page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.products-page .page-header h3 {\n  font-size: 28px;\n  font-weight: 600;\n  color: #111827;\n}\n\n/* Reusing your page controls and search bar styles */\n.page-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.filter-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 8px;\n  cursor: pointer;\n}\n.filter-btn img {\n  height: 20px;\n}\n.page-search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 0 12px;\n  width: 300px;\n}\n.page-search-bar img {\n  height: 16px;\n  opacity: 0.5;\n}\n.page-search-bar input {\n  border: none;\n  outline: none;\n  padding: 10px 8px;\n  font-size: 14px;\n  flex-grow: 1;\n  background: transparent;\n}\n\n/* === MAIN CONTENT WRAPPER & TABS === */\n.page-content-wrapper {\n  background: #ffffff;\n  border: 1px solid #f3f4f6;\n  border-radius: 12px;\n  padding: 24px;\n}\n.product-tabs {\n  border-bottom: 2px solid #f3f4f6;\n}\n.product-tabs button {\n  background: none;\n  border: none;\n  padding: 0 5px 15px 5px;\n  margin-right: 30px;\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n  position: relative;\n  font-weight: 500;\n}\n.product-tabs button.active {\n  color: #f97316;\n  font-weight: 600;\n}\n.product-tabs button.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #f97316;\n}\n.product-content {\n  padding-top: 24px;\n}\n\n@media (max-width: 900px) {\n  .page-content-wrapper {\n    padding: 12px;\n  }\n  .product-tabs button {\n    margin-right: 12px;\n    font-size: 14px;\n  }\n}\n@media (max-width: 600px) {\n  .page-content-wrapper {\n    padding: 8px;\n  }\n  .product-tabs {\n    flex-wrap: wrap;\n  }\n}\n\n/* === TABLE & PAGINATION STYLES (REUSED FROM YOUR REFERENCE) === */\n.table-container {\n  overflow-x: auto;\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.data-table th,\n.data-table td {\n  padding: 16px 24px;\n  text-align: left;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 14px;\n  white-space: nowrap;\n  vertical-align: middle; /* Ensures content aligns nicely */\n}\n.data-table th {\n  background-color: #f2f7ff;\n  color: #1e3a8a;\n  font-weight: 600;\n  text-transform: none;\n}\n.data-table td {\n  color: #374151;\n}\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.action-icon {\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n  height: 18px;\n}\n.action-icon:hover {\n  opacity: 1;\n}\n\n/* Specific style for the product image in the table */\n.product-image {\n  width: 40px;\n  height: 40px;\n  border-radius: 6px;\n  object-fit: cover;\n}\n\n/* Reusing your status badge styles */\n.status-badge {\n  padding: 5px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n.status-active {\n  background-color: #def7ec;\n  color: #046c4e;\n}\n.status-inactive {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n/* You can add more status colors here as needed */\n\n/* Reusing your page footer and pagination styles */\n\n/* Placeholder and loading styles */\n.page-loading,\n.page-error {\n  text-align: center;\n  padding: 40px;\n  font-size: 18px;\n  color: #6b7280;\n}\n\n.status-dropdown-container {\n  position: relative;\n  display: inline-block;\n}\n\n.status-badge-wrapper {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  background: white;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  width: 200px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.dropdown-item {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.dropdown-item:hover {\n  background-color: #f5f5f5;\n}\n\n.chevron-icon {\n  width: 12px;\n  height: 12px;\n  transition: transform 0.2s;\n}\n\n.chevron-icon.open {\n  transform: rotate(180deg);\n}\n\n.status-badge {\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s ease;\n}\n\n.status-badge-wrapper.updating {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.loading-spinner {\n  width: 12px;\n  height: 12px;\n  border: 2px solid #ffffff;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Status Colors */\n.bg-blue-100 {\n  background-color: #dbeafe;\n}\n.text-blue-800 {\n  color: #1e40af;\n}\n\n.bg-green-100 {\n  background-color: #dcfce7;\n}\n.text-green-800 {\n  color: #166534;\n}\n\n.bg-red-100 {\n  background-color: #fee2e2;\n}\n.text-red-800 {\n  color: #991b1b;\n}\n\n.bg-yellow-100 {\n  background-color: #fef9c3;\n}\n.text-yellow-800 {\n  color: #854d0e;\n}\n\n.bg-purple-100 {\n  background-color: #f3e8ff;\n}\n.text-purple-800 {\n  color: #6b21a8;\n}\n\n.bg-indigo-100 {\n  background-color: #e0e7ff;\n}\n.text-indigo-800 {\n  color: #3730a3;\n}\n\n.bg-gray-100 {\n  background-color: #f3f4f6;\n}\n.text-gray-800 {\n  color: #1f2937;\n}\n\n.dropdown-item {\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 4px;\n  margin: 4px;\n}\n\n.dropdown-item:hover {\n  opacity: 0.8;\n}\n\n.action-cell {\n  white-space: nowrap;\n  /* background-color: #6b21a8; */\n  display: flex;\n  justify-content: start;\n}\n\n.center-text {\n  text-align: center;\n}\n\n.action-icon {\n  width: 20px;\n  height: 20px;\n  margin: 0 5px;\n  cursor: pointer;\n}\n.products-page .all-products-tab > .list-header {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
